import {
  AITicket,
  ESupportTicketStatus,
  SupportTicketResponse,
  TicketStatus,
} from "./aiTickets.types";

const STATUS_BE_TO_UI: Record<ESupportTicketStatus, TicketStatus> = {
  [ESupportTicketStatus.Open]: "Open",
  [ESupportTicketStatus.InProgress]: "Processing",
  [ESupportTicketStatus.WaitingForCustomer]: "Processing",
  [ESupportTicketStatus.Resolved]: "Resolved",
  [ESupportTicketStatus.Closed]: "Closed",
};

const STATUS_UI_TO_BE: Record<TicketStatus, ESupportTicketStatus> = {
  Open: ESupportTicketStatus.Open,
  Processing: ESupportTicketStatus.InProgress,
  Resolved: ESupportTicketStatus.Resolved,
  Closed: ESupportTicketStatus.Closed,
};

export const mapBeStatusToUi = (s: ESupportTicketStatus): TicketStatus =>
  STATUS_BE_TO_UI[s];

export const mapUiStatusToBe = (s: TicketStatus): ESupportTicketStatus =>
  STATUS_UI_TO_BE[s];

const formatDate = (iso: string): string => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const mapTicket = (r: SupportTicketResponse): AITicket => ({
  id: r.id,
  title: r.title,
  description: r.aiSummary ?? "",
  body: r.aiSummary ?? "",
  assignedAgent: null,
  status: mapBeStatusToUi(r.status),
  dateCreated: formatDate(r.createdAt),
  raw: r,
});

// The ticket the modal shows: the one on the current tab and page, else the
// one a `?ticketId=` link named, loaded on its own (it may be resolved, or on
// another page). Null when neither holds the selected id.
export const pickSelectedTicket = (
  tickets: AITicket[],
  selectedId: string | null,
  linked: SupportTicketResponse | null | undefined,
): AITicket | null => {
  if (!selectedId) return null;
  const listed = tickets.find((tk) => tk.id === selectedId);
  if (listed) return listed;
  return linked && linked.id === selectedId ? mapTicket(linked) : null;
};
